/*
 * サブシステム名：マスタ管理
 * 機能名：発注先マスタ登録（※取引先マスタ登録ベース）
 */

import D2MSTD0020 from '@/views/MST/D2MSTD0020.js'

export default ({
  extends: D2MSTD0020,
  name: 'MstHacchusakiEdit',
  methods: {
    // 発注先設定
    setHacchusaki: function () {
      this.hacchusakiFlg = true
    }
  }
})
